import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n/lib';

function ProductTabRowHeader({ firstColumnName, secondColumnName }) {
  return (
    <Wrapper>
      <LeftWrapper>{firstColumnName}</LeftWrapper>
      <div>{secondColumnName}</div>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin: 0;
  padding-bottom: 16px;
  border-radius: ${rem(2)};
  background-color: ${({ theme }) => theme.colors.contentBackground};
  justify-content: space-between;
  align-items: stretch;
  color: ${({ theme }) => theme.color.black};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }

  ${({ theme }) => theme.mediab.l925`
    max-width: initial;
  `}

  ${({ theme }) => theme.mediab.m760`
    margin: 0 auto;
    max-width: initial;
    width: 100%;
    &:last-child {
      margin: 0 auto;
    }
  `}
`;

const LeftWrapper = styled(FlexCol)`
  justify-content: space-between;
`;

export { ProductTabRowHeader };
